import { render, staticRenderFns } from "./PlanDocumentActions.vue?vue&type=template&id=5c5a3a76"
import script from "./PlanDocumentActions.vue?vue&type=script&lang=js"
export * from "./PlanDocumentActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports